import { ParamName } from 'entities/FillBtn';
import { FillFieldType, FieldSuccssLoadedType } from './interfaces';
import {
  GET_TRIP_FIELDS_REQUEST,
  GET_TRIP_FIELDS_SUCCESS,
  GET_TRIP_FIELDS_ERROR,
  CLEAN_TRIP_FIELDS_LOADED,
  GET_REQDOC_ERROR,
  SET_TRIP_FIELDS,
  GET_ORDER_WEIGHT_REQUEST,
  GET_ORDER_WEIGHT_SUCCESS,
  GET_ORDER_WEIGHT_ERROR,
  GET_TRIP_ORDERS_REQUEST,
  GET_ORDER_PART_NUM_REQUEST,
  GET_TRIP_ORDERS_SUCCESS,
  GET_TRIP_ORDERS_ERROR,
  CLEAR_ERROR,
} from './constants';
import { Actions } from './actions';

const initialState = {
  reqData: null as FieldSuccssLoadedType | null,
  loading: false as boolean,
  paramName: '' as ParamName,
  loaded: null as {
    type: FillFieldType;
    isError: boolean;
    isFastLine?: boolean;
  } | null,
  error: {},
  showPopUp: false as boolean,

  errorReqData: false as boolean,
  showErrorReqDocText: '' as any,
  showErrorReqDoc: false as boolean,

  newError: null as any,
};

export const tripFieldsReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case SET_TRIP_FIELDS: {
      return {
        ...state,
        trip: action.payload,
      };
    }
    case GET_REQDOC_ERROR: {
      return {
        ...state,
        errorReqData: action.payload,
      };
    }
    case GET_TRIP_FIELDS_REQUEST: {
      return {
        ...state,
        paramName: action.paramName,
        loading: true,
        showPopUp: false,
        loaded: null,
        error: null,
      };
    }
    case GET_TRIP_FIELDS_SUCCESS: {
      const { reqData, loaded } = action.payload;
      return {
        ...state,
        reqData,
        loaded,
        loading: false,
        newError: null,
        error: null,
        showPopUp: false,
      };
    }
    case GET_TRIP_FIELDS_ERROR: {
      return {
        ...state,
        loaded: action.payload,
        loading: false,
      };
    }
    case GET_ORDER_WEIGHT_REQUEST: {
      return {
        ...state,
        loading: true,
        newError: null,
      };
    }
    case GET_ORDER_WEIGHT_ERROR: {
      return {
        ...state,
        loaded: action.payload,
        loading: false,
        newError: action.payload,
        showPopUp: true,
        error: action.payload,
      };
    }
    case GET_ORDER_WEIGHT_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_TRIP_ORDERS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: {},
      };
    }
    case GET_ORDER_PART_NUM_REQUEST: {
      return {
        ...state,
        loading: true,
        error: {},
      };
    }
    case GET_TRIP_ORDERS_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_TRIP_ORDERS_ERROR: {
      return {
        ...state,
        showPopUp: false,
        loading: false,
        showErrorReqDoc: true,
        showErrorReqDocText: action.payload,
      };
    }
    case CLEAN_TRIP_FIELDS_LOADED: {
      return {
        ...state,
        loaded: null,
        loading: false,
        reqData: null,
        paramName: '',
      };
    }
    case CLEAR_ERROR: {
      return {
        ...state,
        showPopUp: false,
        showErrorReqDoc: false,
        showErrorReqDocText: '',
      };
    }
    default: {
      return state;
    }
  }
};
